import { cardType, date, sex } from "./constant";

const { ID_CARD, PORT_PASS, CONTINENTAL_PASS, INLAND_PASS, SOLDIER_PASS, PERMANENT_PASS, OTHER_CARD } = cardType
const { YEAR, MONTH, DAY } = date
const { BOY } = sex

// 身份证：填入表单内数据转换
export function formCardType(CARD_TYPE) {
  switch (CARD_TYPE) {
    case ID_CARD:
      return '居民身份证';
    case PORT_PASS:
      return '普通护照';
    case CONTINENTAL_PASS:
      return '台湾居民来往大陆通行证';
    case INLAND_PASS:
      return '港澳居民来往内地通行证';
    case SOLDIER_PASS:
      return '中国人民解放军';
    case PERMANENT_PASS:
      return '外国人永久居留证';
    default:
      return '居民身份证';
  }
}
//身份证：填入data内数据转换
export function infoCardType(CARD_TYPE) {
  switch (CARD_TYPE) {
    case ID_CARD:
      return '01';
    case CONTINENTAL_PASS:
      return '06';
    case INLAND_PASS:
      return '02';
    case PORT_PASS:
      return '05';
    case OTHER_CARD:
      return '05';
    default:
  }
}

export function labelRenderer(type, data) {
  switch (type) {
    case YEAR:
      return data + '年'
    case MONTH:
      return data + '月'
    case DAY:
      return data + '日'
    default:
      return data
  }
}

export function judgeSex(sex) {
  return Number(sex) === BOY ? '男' : '女'
}

// 身份证：隐藏中间5-15的数字
export const userInfoHide = (userInfo) => userInfo &&
  userInfo.idNum.split('').map(
    (item, index) =>
      index > 5 && index < 15 ? '*' : item
  ).join('')


/**
*  隐藏中间部分
* @param num  号码、姓名
* @param start  开始位置
* @param end   结束位置
* @returns
*/
export function idCardHide(num, start = 5, end = 16) {
  if(!num)return ''
  // 计算需要隐藏的字符串
  const str = '*'.repeat(end - start)
  if (num) {
    return num.replace(num.substring(start, end), str)
  }
  return ''
}
